import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import api from "../api/api";
import { Data, Root } from "../../types/dashboard";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../store";

interface ContactState {
  contact: Data | null;
  loading: boolean;
  error: string | null;
  success: string | null;
}

const initialState: ContactState = {
  contact: null,
  loading: false,
  error: null,
  success: null,
};

export const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    // optional manual setters if you still want to update state directly
    setUser: (state, action:PayloadAction<Data>) => {
      state.contact = action.payload;
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(getUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })

      .addCase(getUser.fulfilled, (state, action) => {
        state.contact = action.payload; // Update state with fetched contact data
        state.loading = false;
        state.success = "Contact loaded successfully";
      })
      .addCase(getUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

        
     
  },
});

export const { setUser} = contactSlice.actions;

export default contactSlice.reducer;

export const getUser = createAsyncThunk<
  Data,          
  void,           
  { rejectValue: string; state: RootState }    
>(
  "contact/getUser",
  async (_ ,{ rejectWithValue }) => {
    try {
      const response = await api.get(`ContactInfo`);
      if (response.data) {
        const params = new URL(window.location as any).searchParams;
        const pathname = window.location.pathname;
        const ALLOWED_INCOMPLETE_PATHS = ['/photo-management'];

        if (
            !response.data.IsProfileCompleted &&
            null === params.get('incomplete') &&
            !ALLOWED_INCOMPLETE_PATHS.includes(pathname)
        ) {
            window.location.href = '/account/?incomplete';
             throw new Error('Incomplete profile');
        }
        return response.data;
        
      } else {
        console.error(response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const { contact } = getState();
      if (contact.loading || contact.contact !== null) {
        // Already fetching or fetched, cancel this dispatch
        return false;
      }
    }
  }
);
  

